import * as React from "react";
import chatLogo from "../../users/chat/img/data1.png";
import FullChat from "@chat-app/components/full-chat";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import { loadAdminChatrooms } from "@chat-app/socket-functions";
import { ObjectId } from "@app/utils/generics";
import { IChatRootState } from "@chat-app/rootReducer";

const Container = styled.div`
	width: 100%;
	height: calc(100vh - 80px);
	background-color: #0f0e17;
`;

interface IOwnProps {
	courseId: ObjectId;
}
type IStateProps = ReturnType<typeof mapStateToProps>;
type IProps = IOwnProps & IStateProps;

class AdminChatComponent extends React.Component<IProps> {
	render() {
		return (
			<Container>
				<FullChat
					userId={"c" + this.props.courseId}
					uniPicture={chatLogo}
					messageContainerStyle={{
						userColor: "#a9a9a9",
						otherColor: "#ff780d",
					}}
				/>
			</Container>
		);
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.lastLoadTime) {
			loadAdminChatrooms({ type: "course", id: this.props.courseId });
		} else if (
			this.props.lastLoadTime.getTime() !==
			nextProps.lastLoadTime.getTime()
		) {
			loadAdminChatrooms({ type: "course", id: this.props.courseId });
		}
	}

	componentDidMount() {
		loadAdminChatrooms({ type: "course", id: this.props.courseId });
	}
}

const mapStateToProps = (state: IChatRootState) => ({
	lastLoadTime: state.chatrooms.lastUpdate,
});

export default connect<IStateProps, any, IOwnProps>(mapStateToProps)(
	AdminChatComponent
);
